import { useTranslation } from 'react-i18next';

const halfOpacity = {
    opacity: .5,
};

export const Loading = () => {
    const { t } = useTranslation();
    return (
        <span style={ halfOpacity }>
            { t('LOADING') }
        </span>
    );
};
